import hairoilRecommender from './code/Scripts/components/hairoil-recommender/hairoil-recommender.vue';
import prQuestion from './code/Scripts/components/pr-question/pr-question.vue';
import prResult from './code/Scripts/components/pr-result/pr-result.vue';

export default {
  components: {
    hairoilRecommender,
    prQuestion,
    prResult,
  },
};
